import { FormEvent, useState } from "react";
import PageHeaderMenu from "../Auth/Menu";
import { userChangePassword } from "../../Services/Auth";
import { CenteredPageDiv } from "../../styles/global.styles";
import {
  AccountButton,
  AccountContentButton,
  AccountForm,
  AccountFormControl,
  AccountInputLabel,
  AccountOutlinedInput,
  TextH2,
} from "../../Components/Account/styles";

function ChangePasswordContent() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    await userChangePassword(currentPassword, newPassword, newPassword);
    setCurrentPassword("");
    setNewPassword("");
  };

  return (
    <CenteredPageDiv>
      <AccountForm onSubmit={handleSubmit}>
        <TextH2>Alterar Senha</TextH2>
        <br />
        <AccountFormControl variant="outlined">
          <AccountInputLabel htmlFor="currentPassword">
            Senha Atual
          </AccountInputLabel>
          <AccountOutlinedInput
            autoComplete="current-password"
            id="currentPassword"
            inputProps={{ minLength: 8, maxLength: 30 }}
            label="Senha Atual"
            onChange={(event) => setCurrentPassword(event.target.value)}
            required
            type="password"
            value={currentPassword}
          />
        </AccountFormControl>
        <br />
        <br />
        <AccountFormControl variant="outlined">
          <AccountInputLabel htmlFor="newPassword">
            Nova Senha
          </AccountInputLabel>
          <AccountOutlinedInput
            autoComplete="new-password"
            id="newPassword"
            inputProps={{ minLength: 8, maxLength: 30 }}
            label="Nova Senha"
            onChange={(event) => setNewPassword(event.target.value)}
            required
            type="password"
            value={newPassword}
          />
        </AccountFormControl>
        <AccountContentButton>
          <AccountButton title="Salvar nova senha">Salvar nova senha</AccountButton>
        </AccountContentButton>
      </AccountForm>
    </CenteredPageDiv>
  );
}

function ChangePasswordPage() {
  return <PageHeaderMenu InternalComponent={<ChangePasswordContent />} />;
}

export default ChangePasswordPage;
